module.exports = __webpack_public_path__ + "static/img/k24_kw_01.68d18901.png";